import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { queryClient } from '@src/services/common/query-client';
import { ANTD_THEME } from '@shared/constants/antd';

// Only import ReactQueryDevtools in development
const ReactQueryDevtools =
  process.env.NODE_ENV === 'development'
    ? React.lazy(() =>
        import('@tanstack/react-query-devtools').then((mod) => ({
          default: mod.ReactQueryDevtools,
        })),
      )
    : null;

const { baseUrl } = window.conviva;

const ProviderWrapper = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {process.env.NODE_ENV === 'development' && ReactQueryDevtools && (
        <React.Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </React.Suspense>
      )}
      <ConfigProvider
        theme={ANTD_THEME}
        prefixCls="gm-ant"
        // mount within the app space for dark mode
        getPopupContainer={() => document.getElementById('gm-popup-container')!}
      >
        <BrowserRouter basename={baseUrl}>{children}</BrowserRouter>
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default ProviderWrapper;
